<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapBaseRoutes"
        @reset="resetHandle"
        @addOrEdit="addEditHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="80px" @keyup.enter.native="loadData(1)">
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="物料号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料号" clearable/>
            </el-form-item>
            <el-form-item label="物料描述">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料描述" clearable/>
            </el-form-item>
            <el-form-item label="工艺路线组">
              <el-input v-model.trim="filter.plnnr" placeholder="请输入工艺路线组" clearable/>
            </el-form-item>
          </el-form>
        </div>
      </template>
<!--      <template slot="actionBtn" slot-scope="scope">-->
<!--        <el-button-->
<!--            v-if="limits.subAuth"-->
<!--            type="primary"-->
<!--            :loading="submitLoading"-->
<!--            :disabled="scope.row.status !== 10"-->
<!--            @click="submitHandle(scope.row)">-->
<!--          变-->
<!--        </el-button>-->
<!--      </template>-->
    </view-table>
    <sap-base-route-edit ref="sapBaseRouteEdit"/>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable";
  import SapBaseRouteEdit from "@/views/information/SapBaseRoute/SapBaseRouteEdit";

  export default {
    name: "SapBaseRouteList",
    components: {ViewTable,SapBaseRouteEdit},
    data() {
      return {
        limits: {
          editAuth: this.$auth(7),
        },
        filter: {
          specification:"",
          materialNo:"",
          materialName:"",
          plnnr:"",
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "matnr",
            width: 130,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.sapBaseRouteEdit.open(params.row,true);
                    },
                  },
                },
                params.row.matnr,
              );
            },
          },
          {
            key: "action",
            width: 250,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      addEditHandle(row) {
        this.$refs.sapBaseRouteEdit.open(row,false);
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.demandStatus !== "Y") {
          return  false;
        } else {
          return  true;
        }
      },
    },
  };
</script>
